var styles = {"fontElementMap":"mJWBC","orderedlist":"VPUaP","bulletedlist":"S5va1","listItem":"QK5MW"};

export { styles as s };
//# sourceMappingURL=lists-c92b5425.js.map
